import { getSharedState } from "./windowBus";

// Generic change-broadcast for appState (see state.ts). appState stays a
// single plain mutable object for the whole React migration - there's no
// funnel point to intercept every vanilla mutation, so instead: any vanilla
// mutation site that a React-migrated feature also reads gets one added
// notifyStateChange() call after the mutation. React features do the same
// after writing appState.field = x directly, so remaining vanilla readers
// keep working unchanged.
//
// Backed by windowBus, not a plain module-level Set, because app.js and
// react-app.js are separately-bundled IIFEs with no shared module state -
// see windowBus.ts.
function listeners(): Set<() => void> {
  return getSharedState("__stateBusListeners", () => new Set<() => void>());
}

export function onStateChange(fn: () => void): () => void {
  listeners().add(fn);
  return () => listeners().delete(fn);
}

export function notifyStateChange(): void {
  listeners().forEach((fn) => fn());
}
